module.exports = __webpack_public_path__ + "media/images/common/kuchi_5-221a8c32e219aaaf4b30d5b61b9c3fb1.gif";